module.exports = __webpack_public_path__ + "static/img_5.2188489e.jpg";